import React, {PropTypes} from 'react';
import EventQuickList from './EventQuickList.jsx';
import VirtualEventQuickList from './VirtualEventQuickList.jsx';
import DivisionList from './DivisionList.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const Divisions = ({
  eventIdSelected,
  virtualEventIdSelected,
  selectedEventName,
  events,
  virtualEvents,
  divisions,
  onEventClick,
  onVirtualEventClick,
  onDivisionClick,
  onNewDivisionClick,
  canCreateDivision
}) => (
  <div className="flex center animated fadeIn">
    <div className="col-xs-12 col-lg-10">
    {
      events.length || virtualEvents.length
      ? <div>
          <div className="row">
            <div className="col-sm-4 animated fadeIn"
                 style={{marginTop: 10}}>
              {
                events.length
                  ? <div>
                      <h4>{`Bowled Events`}</h4>
                      <EventQuickList
                        entries={events}
                        onSelect={onEventClick}
                      />
                    </div>
                  : null
              }
              {
                virtualEvents.length
                ? <div>
                    <h4>{`Virtual Events`}</h4>
                    <VirtualEventQuickList
                      entries={virtualEvents}
                      onSelect={onVirtualEventClick}
                    />
                  </div>
                : null
              }
            </div>
            {
              (eventIdSelected || virtualEventIdSelected)
              ? <div className="col-sm-8 animated fadeIn">
                  <div className="flex space-between vertical-center" 
                       style={{marginTop: 8, marginBottom: 8}}>
                    <h4>{`${selectedEventName} Divisions`}</h4>
                    <div className="text-right">
                      <button
                        className="btn btn-primary btn-lg"
                        disabled={!eventIdSelected && !virtualEventIdSelected || !canCreateDivision}
                        onClick={onNewDivisionClick}
                      >{`Create Division`}</button>
                    </div>
                  </div> 
                  <ErrorListContainer />
                  {
                    divisions.length
                    ? <DivisionList
                        entries={divisions}
                        onDivisionClick={onDivisionClick}
                      />
                    : <div className="alert alert-info">
                        <strong>{'Heads up! '}</strong>
                        {`No divisions found.`}
                      </div>
                  }
                </div>
              : null
            }
          </div>
        </div>
      : <div className="alert alert-info">{'No information to display.'}</div>
    }
    </div>
  </div>
);

Divisions.propTypes = {
  eventIdSelected: PropTypes.string,
  virtualEventIdSelected: PropTypes.string,
  selectedEventName: PropTypes.string,
  events: PropTypes.arrayOf(PropTypes.object),
  virtualEvents: PropTypes.arrayOf(PropTypes.object),
  divisions: PropTypes.arrayOf(PropTypes.object),
  onEventClick: PropTypes.func,
  onVirtualEventClick: PropTypes.func,
  onDivisionClick: PropTypes.func,
  onNewDivisionClick: PropTypes.func,
  canCreateDivision: PropTypes.bool
};

Divisions.defaultProps = {
  selectedEventName: '',
  events: [],
  virtualEvents: [],
  divisions: []
};

export default Divisions;



// WEBPACK FOOTER //
// ./src/features/tournament/divisions/Divisions.jsx